import { Stage as S, Layer as L, Image as K } from 'react-konva';
import uI from '../../hooks/useImage';
import uM from '../../hooks/useMediaQuery';

const C = ({ bg: b, overlay: o, size: z }) => {
    const bI = uI(b), oI = uI(o), m = uM('(max-width: 1023.98px)');

    if (!bI || !oI) return null;

    return (
        <div className="relative col-span-4 sm:block hidden">
            <S width={ m ? 650 : 800 } height={ 531 }>
                <L>
                    <K image={ bI } width={ 759 } height={ 531 } />
                    <K 
                        image={ oI }
                        x={ 250 } y={ 100 }
                        draggable
                        width={ z.width * 2.9 }
                        height={ z.height * 2.9 }
                        shadowColor="rgba(0, 0, 0, 0.5)"
                        shadowBlur={ 3 }
                        shadowOffsetX={ 1 }
                        shadowOffsetY={ 1 }
                    />
                </L>
            </S>
        </div>
    );
};

export default C;
